<div  class="card pad-rem-2 d-flex justify-content-center">
    <div class="px-2">
        <div class="columnn">
            <div class="row">
                <h2 class="w-100">Confirma la operación de {{data.titulo}}</h2>
            </div>
            <form name="form" (ngSubmit)="finish()" [formGroup]="form" novalidate>
                <div class="row">
                    <h6 class="w-100 subtitle my-3">Introduce el código de seguridad que has recibido para confirmar la operación.</h6>
                    <input autocomplete="off" type="text" name="codigoSeguridad" class="form-control" 
                    formControlName="codigoSeguridad"  />                
                </div>
        
                <div class="witdth-auto-buttons d-flex mt-3 justify-content-between row">
                    
                    <button type="button" (click)="cancel()"  class="py-2 btn btn-secondary m-left footer-btn">{{ 'NOTIFICATION.BUTTON.CANCEL' | translate }}</button>
                    <button  type="submit" class="py-2 btn btn-primary m-left footer-btn">{{ 'COMMON.BUTTON.CONFIRM' | translate }}</button>
                </div>
            </form>
        </div>
    </div>
</div>